import { Table, TableColumnsType } from "antd";
import { IAppVersion } from "models/appVersion";
import moment from "moment";
import useAppVersion from "hooks/useAppVersion";
import { Link } from "react-router-dom";
import { RouteName } from "constants/route";
import AddIcon from "components/Icons/AddIcon";
import { AppVersionAlertContextProvider } from "./components/AlertContext";
import { appVersionBadge } from "components/Table";
import Action from "./components/Action";

export default function AppVersion() {
  const { data } = useAppVersion();

  return (
    <AppVersionAlertContextProvider>
      <div className="w-full">
        <div className="w-full px-6 flex flex-wrap-reverse">
          <div className="grow justify-between items-center flex-wrap-reverse gap-5">
            <Link
              to={RouteName.CREATE_APP_VERSION}
              className="flex items-center p-3 border rounded-lg border-black w-fit gap-x-2"
            >
              <AddIcon />
              <span className="text-black text-sm font-medium">
                Add App Version
              </span>
            </Link>
          </div>
        </div>
        <div className="w-full mt-8 px-4">
          <Table
            loading={data.loading}
            columns={columns}
            dataSource={data.data}
          />
        </div>
      </div>
    </AppVersionAlertContextProvider>
  );
}

const columns: TableColumnsType<IAppVersion> = [
  {
    title: "Version",
    dataIndex: "version",
  },
  {
    title: "Platform",
    dataIndex: "platform",
    render: (platform) => <p className="capitalize">{platform}</p>,
  },
  {
    title: "Description",
    dataIndex: "description",
  },
  {
    title: "Driver Force Update",
    dataIndex: "driver_force_update",
    render: appVersionBadge,
  },
  {
    title: "Passenger Force Update",
    dataIndex: "passenger_force_update",
    render: appVersionBadge,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    render: (createdAt) => <p>{moment(createdAt).format("lll")}</p>,
  },
  {
    title: "Action",
    render: (value: IAppVersion) => <Action appVersion={value} />,
  },
];
